import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FullScreenModal } from 'V2Components'
import { getHTMLDataTestID } from 'infra/utils'
import { Button, TargetIcon, Typography } from 'procyon-ui'
import React from 'react'

const Slack = ({ showInfoModal, setShowInfoModal, handleIntegrationModalClick}) => {
    return (
        <FullScreenModal showModal={showInfoModal}>
        <div className='flex justify-center items-center h-[100%] bg-[#2229455a]'>
          <div className='w-[626px] rounded-lg p-8 bg-[var(--color-common-bg-base)]'>
            <div className='flex justify-between'>
              <Typography variant='h5' className='flex text-2xl items-center font-bold'>
                <TargetIcon
                  width={'48px'}
                  height={'48px'}
                  type={'SLACK'}
                  className='rounded'
                  style={{
                    borderRadius: '12px',
                    marginRight: '15px'
                  }}
                />
                Slack
              </Typography>
              <div className='flex gap-4'>
                <Button 
                  data-testid={getHTMLDataTestID('integration', 'button', 'close', 'slack')}
                  onClick={() => setShowInfoModal(false)} variant='gray' icon={faClose} iconPosition='end'>
                  Close
                </Button>
              </div>
            </div>
            <div className='p-4 mt-2 rounded text-black max-h-[60vh] overflow-auto'>
              <Typography variant='body-small' className='text-sm font-light'>
                Slack is a collaboration platform that streamlines team communication, offering
                channels, messaging, and integrations to enhance productivity and collaboration in
                workplaces.
              </Typography>

              <Typography variant='h5' className='font-regular mt-5 mb-2'>What is Slack?</Typography>
              <Typography variant='body-small' className='font-light'>
                Slack is a collaboration platform designed to facilitate communication and teamwork
                within organizations. It offers a centralized space for team members to communicate,
                share files, and collaborate in real-time. Slack provides channels for organizing
                discussions based on topics, projects, or teams, as well as direct messaging for
                one-on-one conversations. The platform also supports integrations with various
                third-party applications and services, allowing teams to bring their tools into the
                Slack environment. Overall, Slack aims to enhance communication and collaboration,
                making it a popular choice for businesses and teams of all sizes.
              </Typography>
            </div>

            <div className='flex justify-end mt-4'>
              <Button 
                data-testid={getHTMLDataTestID('integration', 'button', 'integrate', 'slack')}
                size='md' onClick={() => handleIntegrationModalClick('slack')} variant='primary'>
                Integrate
              </Button>
            </div>
          </div>
        </div>
      </FullScreenModal>
    )
}

export {Slack}